import { render, staticRenderFns } from "./Sendemail.vue?vue&type=template&id=4ab99f4e"
import script from "./Sendemail.vue?vue&type=script&lang=js"
export * from "./Sendemail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports